import React from "react"

import { ButtonType, IButton } from "./model"

import "./style.scss"

/**
 * Generic button that can be used for different colors including outline and solid, and different sizes.
 */
export function Button({ disabled, className, variant, onClick, scale, style, type, children }: IButton) {
    const managedClick = (event: React.MouseEvent<HTMLSpanElement, MouseEvent>) => {
        if (disabled) {
            event.preventDefault()

            return
        }
        if (onClick) {
            return onClick(event)
        }
    }

    const chooseButton = (value: ButtonType) => {
        switch (value) {
            case "submit":
                return (
                    <button
                        style={style}
                        type="submit"
                        className={`btn btn-${variant} mkt
                            ${className || ""}
                ${scale !== "reg" ? scale : ""} 
                ${disabled ? "disabled" : ""}`}
                    >
                        {children}
                    </button>
                )
            default:
                return (
                    <div
                        className={`btn btn-${variant} ${scale !== "reg" ? scale : ""} ${disabled ? "disabled" : ""} ${
                            className || ""
                        }`}
                        style={style}
                        onClick={managedClick}
                    >
                        {children}
                    </div>
                )
        }
    }

    return chooseButton(type)
}

Button.defaultProps = {
    scale: "reg",
    type: "div",
    variant: "primary",
}
